let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7TFLj")).then(() => parcelRequire('7zGoD'));